import Splide from '@splidejs/splide';

///
// Hero slider
///

function initThumbnail(thumbnail, index) {
  thumbnail.addEventListener('click', function() {
    splide.go(index);
  });
}

const imageGallery = document.querySelectorAll('.splide-hero');
if (imageGallery.length) {

  var splide = new Splide( '#main-carousel', {
    pagination: false,
    type      : 'fade',
    arrows: false,
  } );

  var thumbnails = document.getElementsByClassName( 'hero-carousel-dots__item' );
  var current;

  for ( var i = 0; i < thumbnails.length; i++ ) {
    initThumbnail( thumbnails[ i ], i );
  }

  splide.on( 'mounted move', function () {
    var thumbnail = thumbnails[ splide.index ];

    if ( thumbnail ) {
      if ( current ) {
        current.classList.remove( 'is-active' );
      }

      thumbnail.classList.add( 'is-active' );
      current = thumbnail;
    }
  } );

  splide.mount();

}

///
// Products slider
///


const productGalleries = document.querySelectorAll('.splide-products');

if (productGalleries.length) {
  productGalleries.forEach((gallery, index) => {

    let splide;

    document.addEventListener('DOMContentLoaded', function () {

      splide = new Splide(gallery, {
        autoplay: false,
        gap: '1.5rem',
        updateOnMove: true,
        interval: 7000,
        arrows: false,
        perPage: 2,
        type: 'loop',
        pagination: true,
        keyboard: false,
        slideFocus: false,
        mediaQuery: 'min',
        breakpoints: {
          0: {
            perPage: 1,
          },
          576: {
            perPage: 2,
          },
          992: {
            perPage: 3,
          },
          1200: {
            perPage: 2,
          },
        }
      }).mount();

      splide.on('move', function () {
        const slides = gallery.querySelectorAll('.splide__slide');
        slides.forEach(function (slide) {
          slide.classList.add('is-visible');
        });
      });

    });
  });
}


///
// Content slider
///

const contentSlider = document.querySelectorAll('.splide-content');
if (contentSlider.length) {
  for (let i = 0; i < contentSlider.length; i++) {

    let splide;

    document.addEventListener('DOMContentLoaded', function () {

      splide = new Splide('.splide-content', {
        autoplay: false,
        updateOnMove: true,
        interval: 7000,
        arrows: true,
        perPage: 1,
        type: 'loop',
        pagination: true,
        keyboard: false,
        slideFocus: false,
      }).mount();

      // To prevent animation issues, let's make every slide visible before a transition happens. Splide will then automatically remove the `.is-visible` class from non-visible slides once the transition is finished.
      splide.on('move', function () {
        const slides = document.querySelectorAll('.splide-content .splide__slide');
        slides.forEach(function (slide) {
          slide.classList.add('is-visible');
        });
      });

    });
  }
}


///
// Image slider
///

const imageSlider = document.querySelectorAll('.splide-images');
if (imageSlider.length) {
  for (let i = 0; i < imageSlider.length; i++) {

    let splide;

    document.addEventListener('DOMContentLoaded', function () {

      splide = new Splide('.splide-images', {
        autoplay: false,
        updateOnMove: true,
        interval: 7000,
        arrows: true,
        perPage: 1,
        type: 'loop',
        pagination: true,
        keyboard: false,
        slideFocus: false,
      }).mount();

      // To prevent animation issues, let's make every slide visible before a transition happens. Splide will then automatically remove the `.is-visible` class from non-visible slides once the transition is finished.
      splide.on('move', function () {
        const slides = document.querySelectorAll('.splide-images .splide__slide');
        slides.forEach(function (slide) {
          slide.classList.add('is-visible');
        });
      });

    });
  }
}

///
// Image slider
///

const teaserSlider = document.querySelectorAll('.splide-teaser');
if (teaserSlider.length) {
  for (let i = 0; i < teaserSlider.length; i++) {

    let splide;

    document.addEventListener('DOMContentLoaded', function () {

      splide = new Splide('.splide-teaser', {
        autoplay: false,
        updateOnMove: true,
        interval: 7000,
        arrows: true,
        perPage: 1,
        type: 'loop',
        pagination: true,
        keyboard: false,
        slideFocus: false,
        mediaQuery: 'min',
        breakpoints: {
          1900: {
            destroy: 'completely',
          },
        }
      }).mount();

      // To prevent animation issues, let's make every slide visible before a transition happens. Splide will then automatically remove the `.is-visible` class from non-visible slides once the transition is finished.
      splide.on('move', function () {
        const slides = document.querySelectorAll('.splide-teaser .splide__slide');
        slides.forEach(function (slide) {
          slide.classList.add('is-visible');
        });
      });

    });
  }
}


///
// Products slider
///

const productDetailGallery = document.querySelectorAll('.splide-product');
if (productDetailGallery.length) {
  document.addEventListener( 'DOMContentLoaded', function () {
    var main = new Splide('#main-carousel', {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: true,
    });

    var thumbnails = new Splide( '#thumbnail-carousel', {
      fixedWidth  : 64,
      fixedHeight : 64,
      rewind      : true,
      pagination  : false,
      gap         : 24,
      arrows: false,
      isNavigation: true,
      breakpoints : {
        600: {
          fixedWidth : 64,
          fixedHeight: 64,
        },
      },
    } );

    main.sync( thumbnails );
    main.mount();
    thumbnails.mount();
  } );
}


///
// Testimonial
///

const testimonialDetailGallery = document.querySelectorAll('.splide-testimonial');
if (testimonialDetailGallery.length) {
  document.addEventListener( 'DOMContentLoaded', function () {
    var main = new Splide( '#main-carousel', {
      type      : 'fade',
      rewind    : true,
      pagination: false,
      arrows    : false,
    } );

    var thumbnails = new Splide( '#thumbnail-carousel', {
      perPage: 3,
      autoWidth: true,
      autoHeight: true,
      arrows: false,
      // gap         : 22.25,
      direction: 'ttb',
      rewind      : true,
      pagination  : false,
      isNavigation: true,
      mediaQuery: 'min',
      breakpoints: {
        0: {
          destroy: 'completely'
        },
        992: {
          destroy: false,
          height : 438,
          perPage: 4,
          gap: 20,
        },
        1200: {
          height : 523.75,
          perPage: 4,
          gap: 20.75,
        },
        1400: {
          height : 609,
          perPage: 4,
          gap: 22.25,
        },
      }
    } );

    main.sync( thumbnails );
    main.mount();
    thumbnails.mount();
  } );
}
